import styled from "styled-components";

export const SourceOfFundsBox = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    padding: 0 5rem;
    text-align: center;
    font-family: ${({theme}) => theme.font.family.body};
    font-size: 1.5rem;
    color: ${({theme}) => theme.colors.textLight};
    max-width: 60rem;
`;